<template>
  <div class="flex flex-wrap justify-center">
    <!-- <div class="title flex justify-center">
      <span>Preview</span>
    </div> -->
    <div
      v-for="outfit in outfitArray"
      :key="outfit.id"
      class="outfit-layout"
    >
      <div class="outfit-layout--title flex justify-center">
        <span>{{ outfit.name }}</span>
      </div>
      <p class="outfit-description">
        {{ outfit.comment }}
      </p>
      <div class="outfit-layout--products flex justify-center flex-column vertical-align">
        <div
            v-for="products in outfit.productsRow"
            :key="products.variantId"
            class="flex flex-row justify-center"
          >
          <div
            v-for="product in products"
            :key="product.variantId"
            class="outfit-product"
          >
            <template>
              <div class="product-brand">
                {{ product.brand ? product.brand.name : "" }}
              </div>

              <div
                v-lazy-container="{ selector: 'img' }"
              >
                <img
                  :data-src="product.thumbnail"
                  :alt="product.brand ? product.brand.name : 'Product image'"
                  class="product-image"
                >
              </div>
              <div class="product-price">
                {{
                  product.price.sales_price
                    ? product.price.sales_price
                    : product.price.regular_price | toCurrency
                }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'CustomerViewModal',
  props: [
    'outfitArray'
  ]
}
</script>

<style lang="less" scoped>
@import "../../styles/variables.less";

@responsive-breakpoint: 1600px;

.pre-wrap {
  white-space: pre-wrap;
}

.title {
  width: 100%;
  background: #000c27;
  height: 54px;
  align-items: center;
  margin: 0 -20px;

  span {
    font-size: 26px;
    font-family: @font-primary;
    letter-spacing: 0px;
    color: #F09491;
  }
}

.outfit-layout {
  width: 100%;
  padding: 0 20px;

  &--title {
    background: #F09491;
    height: 54px;
    align-items: center;
    margin: 0 -20px;

    span {
      font-size: 26px;
      font-family: @font-primary;
      letter-spacing: 0px;
      color: #FFFFFF;
    }
  }

  &--products {
    padding-bottom: 50px;
    overflow: auto;

    @media screen and (max-width: @responsive-breakpoint) {
      padding-bottom: 40px;
      justify-content: center;
    }

    .outfit-product {
      margin-right: 10px;
      margin-right: 10px;
      margin-top: 20px;
      box-shadow: 0px 3px 12px #00000029;
      border-radius: 10px;
      padding: 10px;
      background: white;

      .product-brand {
        color: #000000;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        margin-top: 10px;
        height: 18px;
      }

      .product-image {
        height: 150px;
      }

      .product-price {
        color: #000000;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
      }
    }
  }

  .outfit-description {
    max-width: 90%;
    margin: 30px auto 10px auto;
    font-size: 25px;
    color: #000000;
    font-family: @font-primary;
    text-align: center;
    @media screen and (max-width: @responsive-breakpoint) {
      max-width: 90%;
      margin: 20px auto;
      font-size: 14px;
    }
  }
}
</style>
